import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import config from 'config'

import WidgetPage from 'components/hocs/widget-page'
import WidgetContext from 'components/widget-context'
import SimpleCta from 'components/simple-cta'

const variations = {
  'learn-more': 'Learn More',
  'learn-about-home-insurance': 'Learn About Home Insurance',
  'compare-quotes': 'Compare Quotes',
  'get-home-insurance-quotes': 'Get Home Insurance Quotes',
}

const SimpleCtaApp = (props) => {
  const { variation } = props

  const widgetContext = useContext(WidgetContext)

  const {
    options: {
      product: { customCTA },
    },
  } = widgetContext

  switch (variation) {
    default:
      return (
        <SimpleCta
          url={`${config.credibleRoot}/insurance/get-started/`}
          variations={variations}
          large={variations[variation]?.length > 20}
          customCTA={customCTA}
          {...props}
        />
      )
  }
}

SimpleCtaApp.propTypes = {
  variation: PropTypes.string.isRequired,
  trackSnowplowEvent: PropTypes.func,
  utms: PropTypes.object,
  spContexts: PropTypes.array,
}

export default WidgetPage(SimpleCtaApp)
